module.exports = __webpack_public_path__ + "img/Picture-CC-backGray.27c8a17d.png";